module.exports = __webpack_public_path__ + "img/dpd-logo.b0443a23.png";